import { render, staticRenderFns } from "./TheCollegeCourseItem.vue?vue&type=template&id=e20bc306"
import script from "./TheCollegeCourseItem.vue?vue&type=script&lang=js"
export * from "./TheCollegeCourseItem.vue?vue&type=script&lang=js"
import style0 from "./TheCollegeCourseItem.vue?vue&type=style&index=0&id=e20bc306&prod&lang=less&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports